/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'archiveCustomerRunnerTicketSchemesBySystemGameId',
    message: messages.SUCCESS_ARCHIVE_CUSTOMER_RUNNER_TICKET_SCHEMES_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-ticket-schemes/:systemGameId/archive',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.ARCHIVE_CUSTOMER_RUNNER_TICKET_SCHEME,
    requestSchema: requestSchemas.customerRunnerTicketSchemes.archiveCustomerRunnerTicketSchemesBySystemGameId,
  },
  {
    action: 'createCustomerRunnerTicketSchemeBySystemGameId',
    message: messages.SUCCESS_CREATE_CUSTOMER_RUNNER_TICKET_SCHEME_BY_SYSTEM_GAME_ID,
    method: 'POST',
    path: '/customer/:customerId/runner-ticket-scheme/:systemGameId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CREATE_CUSTOMER_RUNNER_TICKET_SCHEME,
    requestSchema: requestSchemas.customerRunnerTicketSchemes.createCustomerRunnerTicketSchemeBySystemGameId,
  },
  {
    action: 'copyCustomerRunnerTicketSchemesBySystemGameId',
    message: messages.SUCCESS_COPY_CUSTOMER_RUNNER_TICKET_SCHEMES_BY_SYSTEM_GAME_ID,
    method: 'POST',
    path: '/customer/:customerId/runner-ticket-schemes/:systemGameId/copy',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.COPY_CUSTOMER_RUNNER_TICKET_SCHEME,
    requestSchema: requestSchemas.customerRunnerTicketSchemes.copyCustomerRunnerTicketSchemesBySystemGameId,
  },
  {
    action: 'deleteCustomerRunnerTicketSchemesBySystemGameId',
    message: messages.SUCCESS_DELETE_CUSTOMER_RUNNER_TICKET_SCHEMES_BY_SYSTEM_GAME_ID,
    method: 'DELETE',
    path: '/customer/:customerId/runner-ticket-schemes/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DELETE_CUSTOMER_RUNNER_TICKET_SCHEME,
    requestSchema: requestSchemas.customerRunnerTicketSchemes.deleteCustomerRunnerTicketSchemesBySystemGameId,
  },
  {
    action: 'getCustomerRunnerTicketSchemesBySystemGameId',
    message: messages.SUCCESS_GET_CUSTOMER_RUNNER_TICKET_SCHEMES_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/customer/:customerId/runner-ticket-schemes/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_RUNNER_TICKET_SCHEME,
    requestSchema: requestSchemas.customerRunnerTicketSchemes.getCustomerRunnerTicketSchemesBySystemGameId,
    scopes: [
      scopes.CUSTOMER_RUNNER_TICKET_SCHEMES_ARCHIVED_BY_SYSTEM_GAME_ID,
      scopes.CUSTOMER_RUNNER_TICKET_SCHEMES_INPUT_BY_SYSTEM_GAME_ID,
      scopes.DEFAULT,
    ],
  },
  {
    action: 'reorderCustomerRunnerTicketSchemesBySystemGameId',
    message: messages.SUCCESS_REORDER_CUSTOMER_RUNNER_TICKET_SCHEMES_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-ticket-schemes/:systemGameId/reorder',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.REORDER_CUSTOMER_RUNNER_TICKET_SCHEME,
    requestSchema: requestSchemas.customerRunnerTicketSchemes.reorderCustomerRunnerTicketSchemesBySystemGameId,
  },
  {
    action: 'unarchiveCustomerRunnerTicketSchemesBySystemGameId',
    message: messages.SUCCESS_UNARCHIVE_CUSTOMER_RUNNER_TICKET_SCHEMES_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-ticket-schemes/:systemGameId/unarchive',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.UNARCHIVE_CUSTOMER_RUNNER_TICKET_SCHEME,
    requestSchema: requestSchemas.customerRunnerTicketSchemes.unarchiveCustomerRunnerTicketSchemesBySystemGameId,
  },
  {
    action: 'updateCustomerRunnerTicketSchemeById',
    message: messages.SUCCESS_UPDATE_CUSTOMER_RUNNER_TICKET_SCHEME_BY_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-ticket-scheme/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_RUNNER_TICKET_SCHEME,
    requestSchema: requestSchemas.customerRunnerTicketSchemes.updateCustomerRunnerTicketSchemeById,
  },
];
